import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import Entity from "../../models/Entity";

class EntitySearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entities: [],
            term: "",
            existingEntities: [],
            searchTimer: null,
        };

        this.additionalQueryParams = {};
        if (this.props.active === true) {
            this.additionalQueryParams.active = true;
        }
    }

    async componentDidMount() {
        if ((this.props.value ?? null) === null) return;
        const include = Array.isArray(this.props.value)
            ? this.props.value
            : [this.props.value];
        if (include.length === 0) return;
        const entities = await Entity.list({
            include,
        });
        this.setState({ existingEntities: entities, entities });
    }

    async getEntities() {
        const { term } = this.state;
        let exclude = this.props.value;
        if (Array.isArray(exclude) === false) {
            exclude = [exclude];
        }

        return Entity.list(
            Object.assign({ term, exclude }, this.additionalQueryParams)
        );
    }

    onChangeSearch(value) {
        this.setState({ term: value });

        if (this.isLoading) {
            clearTimeout(this.state.searchTimer);
        }

        if (value.length === 0) {
            return this.setState({ searchTimer: null });
        }

        const searchTimer = setTimeout(async () => {
            const entities = await this.getEntities();
            clearTimeout(this.state.searchTimer);
            return this.setState({
                searchTimer: null,
                entities: entities.concat(this.state.existingEntities),
            });
        }, 1000);

        this.setState({ searchTimer });
    }

    emptyListMessage() {
        if (this.isLoading) {
            return "Searching...";
        }

        if (this.state.term.length === 0) {
            return "Type to search for entities";
        }

        return "No entities found";
    }

    onChange(value) {
        const compareValue = Array.isArray(value) ? value : [value];
        const newExisting = [];
        for (const id of compareValue) {
            const existing = newExisting.some(({ _id }) => _id === id);
            if (existing === false) {
                const add =
                    this.state.entities.find(({ _id }) => _id === id) ?? null;
                newExisting.push(add);
            }
        }

        this.setState({
            term: "",
            existingEntities: newExisting,
            entities: newExisting,
        });
        this.props.onChange(value);
    }

    get isLoading() {
        return this.state.searchTimer !== null;
    }

    dropdownOptions() {
        const options = this.state.entities.map((club, i) => ({
            key: i,
            text: `${club.name}`,
            value: club._id,
        }));

        return options;
    }

    render() {
        return (
            <Select
                placeholder={this.props.placeholder ?? "Search for entities..."}
                icon="search"
                selection
                loading={this.isLoading}
                value={this.props.value}
                onSearchChange={({ target }) =>
                    this.onChangeSearch(target.value)
                }
                onChange={(_, props) => this.onChange(props.value)}
                search={(i) => i}
                multiple={this.props.multiple}
                options={this.dropdownOptions()}
                noResultsMessage={this.emptyListMessage()}
                disabled={this.props.disabled ?? false}
                fluid={this.props.fluid ?? false}
                className={"pr-2 " + this.props.className ?? ""}
            />
        );
    }
}

export default EntitySearchSelect;
